export default __webpack_public_path__ + "static/media/MaskGroup.873880c6.svg";